import React, { useEffect, useState } from "react";
import { app_url } from "../../config";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const AddPartnerPlanPackageModal = ({ show, onClose, selectedPlan }) => {
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [packages, setPackages] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");
  const [packageData, setPackageData] = useState({
    type: "",
    location_id: "",
  });
  const [price, setPrice] = useState("");
  const [packageSellingPrice, setPackageSellingPrice] = useState("");
  const [addPPackageLoading, setAddPPackageLoading] = useState(false);
  const location = useLocation();

  const isCashbackRoute = location.pathname.includes("/cashback");

  // console.log(selectedPlan, "check selectedPlan");

  const handleError = (err) => {
    if (err.response) {
      if (err.response.status === 400) {
        toast.error(err.response.data.message || "Bad Request");
      } else if (err.response.status === 401) {
        navigate("/");
      } else if (err.response.status === 500) {
        toast.error(err.response.data.message || "Internal Server Error");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } else {
      onClose();
      toast.error("Network error. Please check your internet connection.");
    }
  };

  useEffect(() => {
    if (show) {
      setPackageData({
        type: "",
        location_id: "",
      });
      setSelectedPackageId("");
      setPackages([]);
    }
  }, [show]);

  const fetchLocations = () => {
    setLoading(true);
    axios
      .get(`${app_url}/api/package/fetchPackageOrCountries?type=global`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setPackages(res?.data?.result?.packages || []);
        } else {
          toast.error(res.data.message || "Failed to fetch locations");
        }
      })
      .catch((err) => {
        setLoading(false);
        handleError(err);
      });
  };

  const fetchPackagesForLocation = () => {
    setLoading(true);
    const { type, location_id } = packageData;

    axios
      .get(
        `${app_url}/api/package/fetchPackageOrCountries?type=${type}&location_id=${location_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setLocations(res?.data?.result?.locations);
          setPackages(res?.data?.result?.packages || []);
        } else {
          toast.error(res.data.message || "Failed to fetch packages");
          setPackages([]);
        }
      })
      .catch((err) => {
        setLoading(false);
        handleError(err);
      });
  };

  const addPackage = () => {
    if (!selectedPackageId || !price || !selectedPlan?.id) return;

    setAddPPackageLoading(true);

    const apiConfig = isCashbackRoute
      ? {
          url: `${app_url}/api/payment/addPackageForCardCashback`,
          data: {
            card_cashback_rule_id: selectedPlan.id,
            package_id: Number(selectedPackageId),
            special_cashback_percentage: Number(price),
          },
        }
      : {
          url: `${app_url}/api/partner/addPackageForPartnerPlan`,
          data: {
            partner_plan_id: selectedPlan.id,
            package_id: Number(selectedPackageId),
            package_discounted_price: Number(price),
            package_selling_price: Number(packageSellingPrice),
          },
        };

    axios
      .post(apiConfig.url, apiConfig.data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAddPPackageLoading(false);
        if (response.data.success) {
          toast.success(response.data.message);

          onClose();
        } else {
          toast.error(response.data.message || "Failed to add package");
        }
      })
      .catch((err) => {
        setAddPPackageLoading(false);
        handleError(err);
      });
  };

  // Update the form submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    addPackage();
  };

  useEffect(() => {
    if (packageData.type === "global") {
      setPackageData((prev) => ({
        ...prev,
        location_id: "",
      }));
    }
  }, [packageData.type]);

  useEffect(() => {
    if (packageData.type === "global") {
      setPackageData((prev) => ({
        ...prev,
        location_id: "",
      }));
    }
  }, [packageData.type]);

  useEffect(() => {
    if (packageData.type) {
      if (packageData.type === "global") {
        fetchLocations();
      }
    }
  }, [packageData.type]);

  useEffect(() => {
    if (packageData.location_id || packageData.type) {
      if (packageData.type !== "global") {
        fetchPackagesForLocation();
      }
    }
  }, [packageData.location_id, packageData.type]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPackageData((prev) => {
      // When type changes, reset location_id to empty string
      if (name === "type") {
        return {
          ...prev,
          [name]: value,
          location_id: "",
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    if (name !== "slug" && selectedPackageId) {
      setSelectedPackageId("");
    }
    setPackages([]);
  };

  const handlePackageSelect = (e) => {
    setSelectedPackageId(e.target.value);
    setPrice(""); // Reset price when package is selected
    setPackageSellingPrice(""); // Reset package selling price when package is selected
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Add Package to{" "}
                {isCashbackRoute
                  ? selectedPlan?.card_name
                  : selectedPlan?.plan_name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="packageType" className="form-label">
                    Package Type
                  </label>
                  <select
                    className="form-select"
                    id="packageType"
                    name="type"
                    value={packageData.type}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  >
                    <option value="">Select Package Type</option>
                    <option value="local">Local</option>
                    <option value="regional">Regional</option>
                    <option value="global">Global</option>
                  </select>
                </div>

                {(packageData.type === "local" ||
                  packageData.type === "regional") && (
                  <div className="mb-3">
                    <label htmlFor="location" className="form-label">
                      {packageData.type === "local" ? "Country" : "Region"}
                    </label>
                    <select
                      className="form-select"
                      id="location"
                      name="location_id"
                      value={packageData.location_id}
                      onChange={handleChange}
                      required
                      disabled={loading || locations.length === 0}
                    >
                      <option value="">
                        Select{" "}
                        {packageData.type === "local" ? "Country" : "Region"}
                      </option>
                      {locations.map((location) => (
                        <option key={location.id} value={location.id}>
                          {packageData.type === "local"
                            ? location.name
                            : location.regionName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {packages.length > 0 && (
                  <div className="mb-3">
                    <label htmlFor="package" className="form-label">
                      Select Package
                    </label>
                    <select
                      className="form-select"
                      id="package"
                      value={selectedPackageId}
                      onChange={handlePackageSelect}
                      required
                      disabled={loading}
                    >
                      <option value="">Select a package</option>
                      {packages.map((pkg) => (
                        <option key={pkg.id} value={pkg.id}>
                          {pkg.carrierName} - {pkg.packageName} - ${pkg.price}{" "}
                          USD
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {selectedPackageId && (
                  <>
                    <div className="mb-3">
                      <label htmlFor="price" className="form-label">
                        {isCashbackRoute
                          ? "Cashback Percentage for this Package"
                          : "Special Discount Price for this Package"}
                      </label>
                      <input
                        className="form-control"
                        id="price"
                        value={price}
                        required
                        disabled={loading}
                        onChange={(e) => setPrice(e.target.value)}
                        type="number"
                        min="0"
                        step={isCashbackRoute ? 0.01 : 0.5}
                        max={isCashbackRoute ? "99.99" : "1000000"}
                        placeholder={
                          isCashbackRoute ? "e.g., 2.00 %" : "e.g., 10.00"
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label
                        htmlFor="package_selling_price"
                        className="form-label"
                      >
                        Selling Price for this Package
                      </label>
                      <input
                        className="form-control"
                        id="price"
                        value={packageSellingPrice}
                        required
                        disabled={loading}
                        onChange={(e) => setPackageSellingPrice(e.target.value)}
                        type="number"
                        // min="0"
                        // step={isCashbackRoute ? 0.01 : 0.5}
                        // max={isCashbackRoute ? "99.99" : "1000000"}
                        placeholder={"e.g., 4.50 USD"}
                      />
                    </div>
                  </>
                )}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                    disabled={addPPackageLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      addPPackageLoading || !selectedPackageId || !price
                    }
                    style={{
                      cursor:
                        addPPackageLoading || !selectedPackageId || !price
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    {addPPackageLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>{" "}
                        Adding...
                      </>
                    ) : (
                      "Add Package"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddPartnerPlanPackageModal;
